import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import { apiCallAdmin } from "./services/api-service";
/* import dock_logo from "./assets/svg/dock_logo.svg"; */
function PreLanding() {
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiCallAdmin("get", "get_role_permission/2");

        if (response?.status === 200) {
          navigate("/dashboard");
          return;
        }

        if (response?.status === 401) {
          document.cookie =
            "redirectPath=" + window.location.href + "; path=/; domain=.mawalog.com";
          document.cookie = "mawalog=; path=/; domain=.mawalog.com";
          window.location.href = accountsUrl;
        }
        /*  const res = await axios.get('/api/check');
        if (res.data.success) {
          navigate('/landing'); // go to landing if successful
        } else {
          navigate('/error'); // or redirect to error/fallback
        } */
      } catch (error) {
        console.error(error);
        /*  navigate('/error'); */
        document.cookie =
          "redirectPath=" +
          window.location.href +
          "; path=/; domain=.mawalog.com";
        document.cookie = "mawalog=; path=/; domain=.mawalog.com";
        window.location.href = accountsUrl;
      }
    };

    fetchData();
  }, [navigate, accountsUrl]);

  return (
    <Container
      fluid
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffff",
        paddingLeft: "0px",
        paddingRight: "0px",
      }}
    >
      {/*   <img src={dock_logo} alt="Dock Icon" width={"500px"} /> */}
    </Container>
  );
}

export default PreLanding;
